const app = angular.module('msi.layout.config', []);

function configure($logProvider) {
  if ($logProvider.debugEnabled) {
    $logProvider.debugEnabled(true);
  }
}

configure.$inject = ['$logProvider'];

app.config(configure);

module.exports = app.name;
